<template>
  <div class="game-manage">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <div>
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          size="small"
          v-model="key"
          @keyup.enter.native="Query"
        ></el-input>
      </div>
      <div> <el-button type="primary" size="small" @click.native="Query">查询</el-button></div>
      <div class="addGame"> <el-button type="primary" size="small"  @click="goToAddGame('/game-manage/add-game')">添加游戏</el-button></div>
    </div>
    <div class="list">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
      >
        <el-table-column
          prop="game_name"
          label="游戏名"
          width="180">
        </el-table-column>
        <el-table-column
          prop="user_count"
          label="在线用户数量">
        </el-table-column>
        <el-table-column
          prop="address"
          label="操作">
          <template slot-scope="scope">
            <el-button type="info" round size="small" @click="goTo('/game-manage/info',scope.row.game_name,scope.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        pages:1,
        limit: 10,
        key: '',
        tableData: [],
        total:0
      }
    },
    methods: {
      getList(){
        this.$get('/v1/admin/game-name-all?&pages=' + this.pages + '&limit=' + this.limit+ '&key=' + this.key, {})
          .then((res) => {
            console.log(res)
            if (res.data.status === 'success') {
              this.tableData = res.data.data.data;
              this.total = res.data.data.total;
            } else {
              this.$msg(res.data.msg)
            }
          });
      },
      Query(){
        this.pages = 1;
        this.getList();
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex %2 === 1) {
          return '';
        } else {
          return 'success-row';
        }
      },
      handleSizeChange(val) {
        this.limit = val;
        this.getList()
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.pages = val;
        this.getList()
        console.log(`当前页: ${val}`);
      },
      goTo(path,game_name,id){
        this.$router.push({
          path:path,
          query:{
            name:encodeURI(game_name),
            id:id
          }
        })
      },
      goToAddGame(path){
        this.$router.push({
          path:path,

        })
      }
    },
    created() {
      this.getList()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .game-manage
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .search
      margin 20px 0
      display flex
      justify-content flex-start

      input
        width 200px
        margin-right 20px

    .list
      min-height 550px
      border 1px solid #EBEEF5

    .block
      margin-top: 10px;

</style>
<style>
.addGame{
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/GameManage/GameManage.vue